import { apiFetch } from '../../../lib/http';

export const parentApi = {
  listStudents({ auth = true } = {}) {
    return apiFetch('/api/v1/parent/students', { method: 'GET', auth });
  },

  getStudent({ studentId, auth = true }) {
    return apiFetch(`/api/v1/parent/students/${encodeURIComponent(studentId)}`, {
      method: 'GET',
      auth,
    });
  },

  listStudentCourses({ studentId, auth = true }) {
    return apiFetch(`/api/v1/parent/students/${encodeURIComponent(studentId)}/courses`, {
      method: 'GET',
      auth,
    });
  },

  getStudentCourse({ studentId, courseId, auth = true }) {
    return apiFetch(
      `/api/v1/parent/students/${encodeURIComponent(studentId)}/courses/${encodeURIComponent(courseId)}`,
      { method: 'GET', auth }
    );
  },

  linkStudent({ code, auth = true }) {
    return apiFetch('/api/v1/parent/students', {
      method: 'POST',
      auth,
      body: { code },
    });
  },

  unlinkStudent({ studentId, auth = true }) {
    return apiFetch(`/api/v1/parent/students/${encodeURIComponent(studentId)}`, {
      method: 'DELETE',
      auth,
    });
  },
};
